import { Text, Container, Flex, Link } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { Trans } from "@lingui/macro";

export default function ThankYou() {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <Container size="1" p="3" height="calc(100vh - 24px)">
      <Flex
        gap="3"
        align="center"
        justify="center"
        height="100%"
        direction="column"
      >
        <Text>
          <Trans id="ThankYou.thank_you">Thank you for your feedback.</Trans>
        </Text>
        <Link href="#" onClick={goHome}>
          <Trans id="ThankYou.submit_another">Submit another response</Trans>
        </Link>
      </Flex>
    </Container>
  );
}
